import React, { useCallback, useEffect, useState } from 'react';
import { Button, HStack, Select, Text } from '@chakra-ui/react';
import { client } from '@php-beam/packages/frontend/src/api/client';
import { route } from '@php-beam/packages/frontend/src/hooks/useRouter';

export default function QuoteSelector({
  leadId,
  activeQuoteId,
  onSelect,
}: {
  leadId: number;
  activeQuoteId: number | null;
  onSelect: (id: number | null) => void;
}) {
  const [quotes, setQuotes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(() => {
    setLoading(true);
    client
      .get(route('leads.quotes.index', { lead: leadId }))
      .then((res) => setQuotes(res.data.quotes ?? []))
      .finally(() => setLoading(false));
  }, [leadId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  if (loading || quotes.length === 0) return null;

  return (
    <HStack mb={3} spacing={2}>
      <Text fontSize="xs" fontWeight="semibold" color="gray.500">
        Existing quote:
      </Text>
      <Select
        size="xs"
        maxW="280px"
        placeholder="Select a quote"
        value={activeQuoteId ?? ''}
        onChange={(e) =>
          onSelect(e.target.value ? Number(e.target.value) : null)
        }
      >
        {quotes.map((q: any) => (
          <option key={q.id} value={q.id}>
            #{q.id} — {q.theme} / {q.type}
          </option>
        ))}
      </Select>
      <Button size="xs" variant="ghost" onClick={refresh}>
        Refresh
      </Button>
    </HStack>
  );
}
